import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { DeleteDialogboxComponent } from '../delete-dialogbox/delete-dialogbox.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PageEvent } from '@angular/material/paginator';
import { CommonConstant, NoRecordFound } from 'src/app/constants/common-constant';
import { StatusDialogboxComponent } from '../status-dialogbox/status-dialogbox.component';

@Component({
  selector: 'app-job',
  templateUrl: './job.component.html',
  styleUrls: ['./job.component.scss']
})
export class JobComponent {
  Title: string = '';
  TagId: number=0;
  JobList: any = [];
  JobTypeList: any = [];
  jobDeleteObj:any={};
  totalRows: number = 0;
  currentPage: number = 0;
  pageSize: number = 9;
  pageSizeOptions: number[] = [9, 18, 27]; 
  enterSearch: string = '';
  searchClose:boolean= false;
  SortColumn: any = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  CommonConstant:any=[];
  NoRecordFound:any=[];
  showData: boolean = false;
  jobStatusObj: any = {};
  constructor(
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private router: Router,
    private EncrDecr:EncrDecrService,
    private toster: ToastrService,
    private modalService: NgbModal
  ) { }
  async ngOnInit()
  {
    this.getJobTypeList();
    this.getJobList();
    this.CommonConstant = CommonConstant;
    this.NoRecordFound = NoRecordFound;
    this.sharedService.setData('Job');
  }
  search(event) {
    if (event.target.value == '') {
      this.currentPage =0;
      this.getJobList();
      this.searchClose = false;
    }
    else{
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.currentPage =0;
      this.getJobList();
      this.searchClose = true;
    }
  }

  Deletepopup(jobId:number,jobName:string) {
    const modalRef = this.modalService.open(DeleteDialogboxComponent , { centered: true, backdrop: 'static', keyboard: false });
    this.jobDeleteObj={
      jobId:jobId,
      jobName: jobName,
      element: 'job'
    }
    modalRef.componentInstance.jobDeleteObj=this.jobDeleteObj;
      modalRef.result.then((result) => {
        if(result === 'delete'){
          this.getJobList();
        }
      }).catch((error) => {
      });
  }

  onEdit(jobId: number, questionTypeText: string) {
    if(jobId>0){
      var encrypted = this.EncrDecr.set('123456$#@$^@1ERF', jobId);
      this.router.navigate(['job/edit', encrypted]);
    }
    else{
      this.router.navigate(['job/add'])
    }
  }
  
  clearSearch()
  {
    this.Title='';
    this.getJobList();
    this.searchClose = false;
  }
  async getJobList(pageEvent?: PageEvent) {  
    this.showData = false;
    const pageIndex = pageEvent ? pageEvent.pageIndex : this.currentPage;
    const objData = {
      title: this.Title?this.Title.trim():'',
      tagId: this.TagId,
      PageNumber: pageIndex + 1, // Include pageIndex in the API call
      PageSize: this.pageSize, 
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.job.GetJobList;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        if (response.success) {
          this.showData = true;
          this.JobList = response.data;
          this.totalRows = 0;
          if(this.JobList.length>0)
          {
            this.totalRows = response.data[0].totalRecords;          
          }
          this.currentPage = pageIndex;
        }
       this.spinner.hide();  
      },
      error: (error) => {
        this.spinner.hide();
        this.toster.error(error.message);
      }
    });
  }

  ViewAppliedJob(jobId:number,title:string )
  {
    if(jobId>0){
      var encrypted = this.EncrDecr.set('123456$#@$^@1ERF', jobId);
      var encryptedType = this.EncrDecr.set('123456$#@$^@1ERF', title);
      this.router.navigate(['job/applied-job', encrypted,encryptedType]);
    }
  }

  async getJobTypeList() {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.job.GetJobTypeList;
    this.commonService.doGet(apiUrl).pipe().subscribe({
      next: async (response) => {
        if (response.success) {
          this.JobTypeList = response.data;
        }
        this.spinner.hide();
      },
      error: (error) => {
        this.spinner.hide();
        this.toster.error(error.message);
      }
    });
  }

  onJobTypeChange()
  {
    this.getJobList();
  }
  
  pageChanged(event) {
      this.currentPage = event.pageIndex;
      this.pageSize = event.pageSize;
       this.getJobList();
  }

  RefreshGrid(){
    this.Title='';
    this.enterSearch = '';
    this.TagId = 0;
    this.searchClose = false;
    this.getJobTypeList();
    this.getJobList();
  }

  onStatus(jobId: number, jobName: string, active: boolean) {
    const modalRef = this.modalService.open(StatusDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.jobStatusObj = {
      jobid: jobId,
      jobname: jobName,
      activejob: active
    }
    modalRef.componentInstance.jobStatusObj = this.jobStatusObj;
    modalRef.result.then((result) => {
      if (result === 'status') {
        this.JobList.forEach((element: { jobId: number; isActive: boolean; }) => {
          if (element.jobId == jobId) {
            element.isActive = active ? false : true
            this.getJobList();
          }
        });
      }
    }).catch((error) => {
    });
  }
}


